const post = {
  id: 1,
  title: 'My Journey from the Army to Software Engineering',
  date: 'March 2024',
  excerpt: "Thirteen years of service taught me discipline, leadership, and how to perform under pressure. Here's how those skills translated directly into a career in tech — and why I'd make the same choice again.",
  body: `Thirteen years in the Army teaches you a lot of things. How to wake up before everyone else. How to lead when you don't have all the answers. How to adapt when the plan falls apart.

What I didn't expect was how directly those skills would carry over into software engineering.

When I started at Codeup in 2021, I was surrounded by people younger than me, many with formal CS backgrounds. I didn't have that. What I had was 13 years of showing up, solving problems under pressure, and learning whatever I needed to learn to get the mission done.

The 22-week bootcamp was intense — 670 hours of Java, Spring Boot, MySQL, JavaScript, and React. There were moments where I felt lost. But the Army taught me that "lost" is temporary and "quit" is a choice. I kept going.

When I got my first role as a Java Developer at CGI, working on federal systems, everything clicked. The discipline, the attention to detail, the ability to communicate across teams — it all transferred.

If you're a veteran thinking about tech: the transition is real work, but the skills you built in service are exactly what engineering teams need. Don't underestimate what you bring to the table.`,
  readTime: '5 min read',
  tags: ['Career', 'Veteran', 'Story'],
};

export default post;
